export default __webpack_public_path__ + "static/media/metamovies.c9fa7a4b.svg";